import React, { ForwardedRef, forwardRef } from "react";
import { SectionCardContainer } from "./SectionCardStyles";
import { NavLink } from "react-router-dom";
import { SectionCardInterface } from "../../interfaces/SectionCardInterface";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";
import { generateLink } from "../../functions/routingFuntion";

export const SectionCard = forwardRef(
  (
    {
      flexDirection,
      right,
      left,
      link,
      background,
      title,
      text,
      img,
      displayNone
    }: SectionCardInterface,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const language = useAppSelector((state) => state.locale.localStorageValue);
    const { t } = useTranslation();

    return (
      <SectionCardContainer
        ref={ref}
        style={{
          background: background,
        }}
      >
        <div
          className="container__standart flex__center width-half adaptive__direction"
          style={{
            flexDirection: flexDirection || "row",
          }}
        >
          <div className="section-card__info flex__center">
            <h2>{title}</h2>
            <p className="big__text">{text}</p>
            {link === true && (
              <NavLink
                to={generateLink("/auth/login", language)}
                className="white__button flex__center width-half"
              >
                {t("marketsPage.blockInfoBtn")}
              </NavLink>
            )}
          </div>
          <div
            className="relative__container"
            style={{
              display: `${displayNone}`
            }}
          >
            <img
              src={img}
              alt=""
              style={{
                right: right,
                left: left,
              }}
            />
          </div>
        </div>
      </SectionCardContainer>
    );
  }
);

export const MSectionCard = motion.create(SectionCard);
